import api from "../../../api/api";
import API_URL from "../../../api/url";
import axios from 'axios';

const WebContactRequest = {
  // categoryList: (page, limit) => api.get(`${API_URL.BASEURL}${API_URL.getCategory}?page=${page}&limit=${limit}`),
  getContactList: (values) => api.get(`${API_URL.BASEURL}${API_URL.webGetContact}`, {
    params: {
      search: values?.search
    }
  }),

  postDeleteContact: (id) => api.delete(`${API_URL.BASEURL}${API_URL.webContactDelete}?id=${id}`),
  postUpdateContact: (values) => api.post(`${API_URL.BASEURL}${API_URL.webUpdateContact}`, values),
  getContactDetail: (id) => api.get(`${API_URL.BASEURL}${API_URL.webContactDetails}?id=${id}`),
  createContact: (values) => api.post(`${API_URL.BASEURL}${API_URL.webCreateContact}`, values),
  
  uploadImage: (formData) => {
    const token = localStorage.getItem("accesstoken");


    return api.post(
      `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=photos`,
      formData,
      {
        headers: {
          token: token ? `${token}` : "",
        },
      }
    );
  }


};



export default WebContactRequest